
setTimeout(init, 500);
async function init() {
  for(const ele of document.querySelectorAll('.dynamicContent')){
    var data = generateCustomerBaseData();
    var params = new URLSearchParams(window.location.search);
    if(params.has("documentNumber")){
      data.DocumentNumber = params.get("documentNumber");
    }
    if(params.has("selectedDocumentType")){
      data.SelectedDocumentType = params.get("selectedDocumentType");
    }
    await loadContent(generteIntegrationUrl(ele.getAttribute('data-url')), data, ele);
    setTimeout(bindContentEvents, 500);
  }
}

//bindContentEvents
function bindContentEvents(){

  for(const invoiceLink of document.querySelectorAll('.invoice-link')){
    invoiceLink.addEventListener('click', event=>{
      event.preventDefault();
      var invNo = event.target.getAttribute('data-invoiceno').trim();
      downloadInvoice(invNo);
    });
  }

  for(const creditLink of document.querySelectorAll('.credit-link')){
    creditLink.addEventListener('click', (event)=>{
      event.preventDefault();
      var creditNo = event.target.getAttribute("data-creditno").trim();
      downloadCreditMemo(creditNo);
    })
  }
  
  let viewStatementLink = document.querySelector('.view-statement');
  viewStatementLink.addEventListener("click", ()=>{
    if(viewStatementLink.hasAttribute("disabled")){
      showSnackbar("Statement generation is in progress. Please wait...");
      return;
    }
    downloadStatement();
  });

    
    for (const ddCollectionReportLink of document.querySelectorAll('.dd-collection-report')) {
        ddCollectionReportLink.addEventListener('click', async event => {
            event.preventDefault();
            const target = event.target;
            var collectionId = target.getAttribute('data-collectionid');
            await downloadDdCollectionReport(collectionId);
        })
    }

  console.log('Bound Content Events');
}
//deleteSalesLine
async function deleteSalesLineClick(e){
  event.preventDefault();
  const target = event.target;
  const data_ordernumber = target.getAttribute('data-ordernumber');
  const data_orderlineno = target.getAttribute('data-orderlineno');
  let result = await deleteSalesLine(data_ordernumber, data_orderlineno);
  if(result){
    let tr = target.closest('tr');
    tr.classList.add('animatedHide');
    let table = tr.closest('table');
    setTimeout(()=>{tr.remove()}, 300);
  }else{
    alert('Sales line not removed.')
  }
}

async function  deleteSalesLine(soNumber, lineNumber){  
  if(!confirm('Are you sure you want to delete this row?')){return;}

  let orderNo = soNumber;
  let orderlineno = lineNumber;
  
  let url = generteIntegrationUrl('/WorldwideTradeForwardAndBackorders/DeleteLine');
  let data = generateCustomerBaseData();
  
  data['orderNo'] = orderNo;
  data['orderlineno'] = orderlineno;
  var result = false;
  
  await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },  
    body: JSON.stringify(data),
    }).then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.text()
  }).then((response) => {
    result = response == 'true';
  })
    .catch(error => {
      console.error('There has been a problem with your fetch operation:', error);
    });
  return result;
}


async function loadContent(url, data, elementToLoad){
  return await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    
    return response.text()
  })
  .then((response) => {
    elementToLoad.innerHTML = response;
  }).
  catch(error => {
    console.error('There has been a problem with your fetch operation:', error);
  });
  
}

function downloadDdCollectionReport(collectionid) {
    var data = generateCustomerBaseData();
    data.CollectionId = collectionid;
    downloadPdfFile(generteIntegrationUrl("/WorldwideTradeAccountDetails/GetDdCollectionReportFile"), data, collectionid + ".pdf");
}  
  
async function downloadPdfFile(url, data, fileName, callback){
  return await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then(resp => resp.arrayBuffer()).then(resp => {
    const file = new Blob([resp], {type: 'application/pdf'});
    const fileURL = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = fileURL;
    link.download = fileName;
    link.click();
    if(callback && {}.toString.call(callback) === '[object Function]'){
      callback();
    }
    
  });
}


function generteIntegrationUrl(path){
  if(!path.startsWith("/")){
    path  = "/" + path;
  }
  //return "https://localhost:44339" + path;
  return "https://" + baseUrl + path;
}

function generateCustomerBaseData(){
  return baseCustomerReportData;  
}

async function downloadInvoice(invNo){
  var data = generateCustomerBaseData();
  data.SalesInvoiceNumber = invNo;
  showLoadingOverlay("Generating invoice file...");
  try{
    await downloadPdfFile(generteIntegrationUrl("/WorldwideTradeAccountDetails/GetSaleInvoiceFile"), data, invNo + ".pdf");
  }finally{
    hideLoadingOverlay();
  }
}

async function downloadCreditMemo(creditNo){
  var data = generateCustomerBaseData();
  data.CreditNo = creditNo;
  showLoadingOverlay("Generating credit memo file...");
  try{
    await downloadPdfFile(generteIntegrationUrl("/WorldwideTradeAccountDetails/GetCreditFile"), data, creditNo + ".pdf");
  }finally{
    hideLoadingOverlay();
  }
}


  
  async function downloadStatement(){
    var data = generateCustomerBaseData();
    showLoadingOverlay("Please wait while we are generating your statement...");
    try{
      await downloadPdfFile(generteIntegrationUrl("/WorldwideTradeAccountDetails/GetCustomerStatement"), data, "Account-Statement.pdf");
    }finally{
      hideLoadingOverlay();
    }
  }
